import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, withHandlers, compose, withState, lifecycle } from 'recompose'
import onClickOutside from 'react-onclickoutside-decorator'

import { getUserDisplayName } from 'app/modules/user/utils'
import * as MeetingSelectors from 'app/modules/meetings/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as ProfileActions from 'app/modules/profile/actions'

import * as ResourcesConstants from 'constants/ResourcesConstants'

import CalendarLinkModal from './component'

export const DYNAMIC_CALENDAR = 'DYNAMIC_CALENDAR'

const CalendarPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm',
}

const getCalendarLink = (orgHandle, user) => {
  if (user === DYNAMIC_CALENDAR) {
    return '{{ sender.profile_schedule_url }}'
  } else {
    return `https://${ResourcesConstants.PROFILE_DOMAIN}/${user.getIn(['profile', 'globalHandle'])}?schedule`
  }
}

const mapStateToProps = state => ({
  orgUsersById: UserSelectors.nonBotOrgUsersAlphabetical(state).toList(),
  currentUser: UserSelectors.currentUser(state),
  calendarConnectedAgentIds: MeetingSelectors.getAgentIdsWithConnectedCalendars(state),
  orgHandle: OrgSelectors.orgHandle(state),
  calendarProfileLoading: PlaybookSelectors.calendarProfileLoading(state),
  enableDynamicCalendarLink: PlaybookSelectors.getIsSequencePlaybook(state) || PlaybookSelectors.getIsEmailPlaybook(state),
  isOutboundSequencePlaybook: PlaybookSelectors.getIsOutboundSequencePlaybook(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchUserProfile: ProfileActions.fetchUserProfile,
      hideCalendarLinkModal: PlaybookActions.hideCalendarLinkModal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedUser', 'setSelectedUser', undefined),
  withState('popoverStep', 'setPopoverStep', CalendarPopoverSteps.SELECT),
  withState('popoverOpen', 'setPopoverOpen', false),
  withState('search', 'setSearch', ''),
  withState('linkText', 'setLinkText', 'Schedule a meeting'),
  withProps(props => {
    const usersWithoutCalendar = props.orgUsersById.filter(
      user =>
        !props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id')
    )
    const usersWithCalendar = props.orgUsersById.filter(
      user => props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id')
    )
    if (!props.search) {
      return {
        usersWithoutCalendar,
        usersWithCalendar,
        currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
        showCurrentUser: true,
        isSearching: false,
      }
    } else {
      const withCalFiltered = usersWithCalendar.filter(user => {
        return getUserDisplayName(user)
          .toLowerCase()
          .includes(props.search.toLowerCase())
      })
      const withoutCalFiltered = usersWithoutCalendar.filter(user => {
        return getUserDisplayName(user)
          .toLowerCase()
          .includes(props.search.toLowerCase())
      })
      const showCurrentUser =
        props.currentUser &&
        (!!props.search &&
          getUserDisplayName(props.currentUser)
            .toLowerCase()
            .includes(props.search.toLowerCase()))
      return {
        usersWithoutCalendar: withoutCalFiltered,
        usersWithCalendar: withCalFiltered,
        currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
        showCurrentUser,
        isSearching: true,
      }
    }
  }),
  withHandlers({
    onPropertySelect: props => user => {
      props.setSelectedUser(user)
      props.actions.fetchUserProfile(user.get('id'))
      props.setPopoverStep(CalendarPopoverSteps.CONFIRM)
    },
    onDynamicCalSelect: props => () => {
      props.setSelectedUser(DYNAMIC_CALENDAR)
      props.setPopoverStep(CalendarPopoverSteps.CONFIRM)
    },
    onDefaultConfirm: props => () => {
      props.setPopoverStep(CalendarPopoverSteps.SELECT)
      const editor = window.tinymce.activeEditor
      let selectedUser = props.selectedUser
      if (selectedUser !== DYNAMIC_CALENDAR) {
        selectedUser = props.orgUsersById.filter(user => user.get('id') === props.selectedUser.get('id')).first()
      }
      editor.insertContent(
        `<a href="${getCalendarLink(props.orgHandle, selectedUser)}">${props.linkText || 'Schedule a meeting'}</a>`
      )
      props.actions.hideCalendarLinkModal()
    },
    onDefaultCancel: props => () => {
      props.setSelectedUser(undefined)
      props.setLinkText('Schedule a meeting')
      props.setPopoverStep(CalendarPopoverSteps.SELECT)
    },
    hideCalendarLinkModal: props => () => {
      props.actions.hideCalendarLinkModal()
    },
    togglePopoverOpen: props => () => {
      props.setPopoverOpen(!props.popoverOpen)
    },
    onSearchChange: props => event => {
      props.setSearch(event.target.value)
    },
    onDefaultChange: props => event => {
      // make sure to escape double quotes
      props.setLinkText(event.target.value)
    },
    onClickOutside: props => () => {
      props.setPopoverOpen(false)
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.isOutboundSequencePlaybook) {
        this.props.setSelectedUser(DYNAMIC_CALENDAR)
        this.props.setPopoverStep(CalendarPopoverSteps.CONFIRM)
      }
    },
  }),
  onClickOutside
)(CalendarLinkModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EditorCalendarLinkModal/index.js